import type { OrgSector, OrgEchelon } from '../api/keycloak-admin/org-config';

/** Default map center (CONUS) used for new tree nodes */
export const DEFAULT_MAP_VIEW = { lat: 39.0, lng: -98.0, zoom: 4 } as const;

/** Default echelon for new nodes */
export const DEFAULT_ECHELON: OrgEchelon = 'tactical';

/** All available sector values — single source of truth for OrgSector type */
export const SECTORS: OrgSector[] = [
  'military', 'law-enforcement', 'fire-ems', 'emergency-management',
  'medical', 'environmental', 'education', 'transportation',
  'utilities', 'private-security', 'international-ngo',
];
